import {addRemoveProductToTobaccoBag, addTobaccoBag, clearAll, edditSupplierBag, editTobacco, getSavedTobaccoReturn, getTobaccoSuppliers, saveTobaccoReturn, submitTobaccoReturn, validateBagNumber} from "../../actions/history.js";
import {clearQuery, editQueryFilter, loadMoreSearchedProducts, prepareQueryOptions} from "../../actions/productQuery.js";
import {getBoughtProducts, getNewProducts} from "../../actions/productLists.js";
import {setDropDown, setModal} from "../../../common/actions/modal.js";

import HistoryTobakComponent from "../../components/history/HistoryTobakComponent.jsx";
import {connect} from "react-redux";
import {createBoundFunction} from "../../../common/util/reselect.js";
import {createFlowControl} from "../../../common/util/flowControl";
import {createLocalization} from "../../../common/util/localization.jsx";
import {scssVariables} from "../../../common/util/config.jsx";

const mapStateToProps = () => {
    const flowControl = createFlowControl();

    return state => ({
        token: state.authentication.token,
        pickupTobaccoDefault: state.authentication.pickupTobaccoDefault,
        freightChargePickupTobacco: state.authentication.freightChargePickupTobacco,
        deviceType: state.view.deviceType,
        productQuery: state.productQuery,
        productImage: state.productImage,
        flowControl: flowControl,
        height: state.view.innerHeight-parseInt(scssVariables.menuHeight),
        width: state.view.innerWidth,
        localization: createLocalization(state),
        signedInAs: state.authentication.signedInAs,
        tobacco: state.history.tobacco,
    });
};

const mapDispatchToProps = {
    addRemoveProductToTobaccoBag,
    loadMoreSearchedProducts,
    editQueryFilter,
    editTobacco,
    edditSupplierBag,
    validateBagNumber,
    addTobaccoBag,
    clearAll,
    submitTobaccoReturn,
    saveTobaccoReturn,
    setModal,
    setDropDown,
    getTobaccoSuppliers,
    prepareQueryOptions,
    getBoughtProducts,
    getNewProducts,
    clearQuery,
    getSavedTobaccoReturn,
};

const myAddRemoveProductToTobaccoBag = createBoundFunction();
const myLoadMoreSearchedProducts = createBoundFunction();
const myEditQueryFilter = createBoundFunction();
const mySubmitTobaccoReturn = createBoundFunction();

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    addRemoveProductToTobaccoBag: myAddRemoveProductToTobaccoBag((product, qty) => dispatchProps.addRemoveProductToTobaccoBag(product, qty)),
    loadMoreSearchedProducts: myLoadMoreSearchedProducts((noOfProducts) => dispatchProps.loadMoreSearchedProducts(stateProps.productQuery, stateProps.productImage, noOfProducts)),
    editQueryFilter: myEditQueryFilter( (change) => dispatchProps.editQueryFilter(stateProps.productQuery, stateProps.productImage, change, 
        myLoadMoreSearchedProducts(() => dispatchProps.loadMoreSearchedProducts(stateProps.productQuery, stateProps.productImage, 50))
    )),
    submitTobaccoReturn: mySubmitTobaccoReturn( (callbackOnSuccess) => dispatchProps.submitTobaccoReturn(stateProps.token, callbackOnSuccess)),
    //saveTobaccoReturn: mySaveTobaccoReturn(() => dispatchProps.saveTobaccoReturn())
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(HistoryTobakComponent);